import { VEHICLES } from "./vehicles";
import { languagePath, englishPath } from "../i18n/routes";
import { LOCATIONS } from "./locations";
import { POPULAR_ROUTES } from "./routes";
import { TEMPO_CITY_SLUGS } from "./cityContent";

import { DIRECTORY_PATHS, DESTINATION_PATHS } from "./destinationPaths";
import APPROVED_DESTINATION_PATHS from "./approvedDestinationPaths.json";

export const STATIC_PATHS = [
    "/", "/about", "/fleet", "/services", "/contact", "/airport-transfer",
    "/railway-transfer", "/outstation", "/tempo-traveller-rental", "/compare",
    "/service-locations", "/privacy-policy", "/terms", "/refund-policy", "/cancellation-policy",
];
export const ENGLISH_PUBLIC_PATHS = [
    ...STATIC_PATHS,
    ...DIRECTORY_PATHS,
    ...DESTINATION_PATHS,
    ...VEHICLES.map((v) => `/${v.slug}`),
    ...LOCATIONS.map((l) => `/taxi-service-${l.slug}`),
    ...TEMPO_CITY_SLUGS.map((s) => `/tempo-traveller-rental-${s}`),
    ...POPULAR_ROUTES.map((r) => `/${r.slug}`),
];
export const HINDI_PUBLIC_PATHS = ENGLISH_PUBLIC_PATHS.map((route) => languagePath(route, "hi"));
export const PUBLIC_PATHS = [...ENGLISH_PUBLIC_PATHS, ...HINDI_PUBLIC_PATHS];
export const SITEMAP_PATHS = PUBLIC_PATHS.filter((route) => { const source = englishPath(route); return !DESTINATION_PATHS.includes(source) || APPROVED_DESTINATION_PATHS.includes(source); });
export const REDIRECTS = {
"/taxi-service-allahabad": "/taxi-service-prayagraj",
"/tempo-traveller-rental-allahabad": "/tempo-traveller-rental-prayagraj",
"/taxi-service-chitrakoot-dham": "/taxi-service-chitrakoot",
"/tempo-traveller-rental-chitrakoot-dham": "/tempo-traveller-rental-chitrakoot",

    "/vvpss-blog/f/diamond-city-wildlife-haven-your-guide-on-how-to-reach-panna": "/taxi-service-panna",
};
for (const [from, to] of Object.entries({ ...REDIRECTS })) REDIRECTS[languagePath(from, "hi")] = languagePath(to, "hi");
REDIRECTS["/hi"] = "/hi/";
export const ADMIN_PATHS = ["/admin", "/admin/login", "/admin/bookings", "/admin/contacts", "/admin/settings", "/admin/content", "/admin/pricing"];
export const taxiCityPath = (slug) => `/taxi-service-${slug}`;